import { useAdminStore } from '~/stores/useAdminStore'
import type { AdminProfile } from '~/types/admin'

export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.path.startsWith('/admin')) return

  const requestFetch = useRequestFetch()
  const adminStore = useAdminStore()
  try {
    const me = await requestFetch<{ admin: AdminProfile }>('/api/admin/me')
    adminStore.applyMe(me.admin)
    adminStore.hydrated = true
    if (me.admin.role === 'support') {
      return navigateTo('/support')
    }
  } catch {
    adminStore.reset()
    adminStore.hydrated = true
    return navigateTo('/auth/login')
  }
})
